import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getBillingListWidgetStyles = () => {
  return StyleSheet.create({
    mainCardTitleStyle: {
      paddingTop: tokens.spacing.SPACING_16,
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    mainCardMultipleSubtitleStyle: {
      paddingTop: tokens.spacing.SPACING_8,
      paddingHorizontal: tokens.spacing.SPACING_16
    },
    flatListStyle: {
      paddingVertical: tokens.spacing.SPACING_16
    },
    cardTitleStyle: {
      paddingHorizontal: tokens.spacing.SPACING_16,
      paddingBottom: tokens.spacing.SPACING_16
    },
    safePadding: {
      paddingTop: tokens.spacing.SPACING_16
    }
  });
};